/* Juanito Games — interacciones del tema */
(() => {
  'use strict';

  const JG = window.JG || (window.JG = {});
  const html = document.documentElement;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = matchMedia('(hover: hover)').matches;
  const parseHTML = (str) => new DOMParser().parseFromString(str, 'text/html');
  const define = (name, cls) => customElements.get(name) || customElements.define(name, cls);

  /* Hoy en la Ciudad de México (AAAA-MM-DD). Las promociones y preventas con fecha (etiquetas _oferta y _preventa)
     las decide Liquid; esto solo corrige una página guardada en caché cuando la fecha ya pasó. */
  const hoy = () => {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  };
  const vigencia = (root = document) => {
    const d = hoy();
    $$('[data-oferta-fin]', root).forEach((el) => {
      if (el.tagName === 'SCRIPT' || d <= el.dataset.ofertaFin) return;
      const now = $('.price__now, .hero__now', el);
      if (now) {
        now.textContent = el.dataset.regular;
        $$('.price__was, .hero__save', el).forEach((x) => x.remove());
        el.classList.remove('price--sale');
      } else {
        el.textContent = el.dataset.regular;
      }
      el.removeAttribute('data-oferta-fin');
    });
    $$('[data-oferta-solo]', root).forEach((el) => d > el.dataset.ofertaSolo && el.remove());
    $$('[data-preventa-fin]', root).forEach((el) => {
      if (d <= el.dataset.preventaFin) return;
      const next = el.nextElementSibling;
      if (next && next.hasAttribute('data-preventa-despues')) next.hidden = false;
      el.remove();
    });
  };

  /* ---------------------------------------------------------------- Avisos */
  JG.toast = (msg, type) => {
    const box = $('#Toasts');
    if (!box) return;
    const t = document.createElement('div');
    t.className = 'toast' + (type === 'err' ? ' toast--err' : '');
    t.textContent = msg;
    box.appendChild(t);
    setTimeout(() => {
      t.classList.add('is-out');
      setTimeout(() => t.remove(), 320);
    }, 2800);
  };

  /* ------------------------------------------------- Cajones y ventana modal */
  let lastFocus = null;
  const overlay = (JG.overlay = {
    open(el) {
      if (!el || el.classList.contains('is-open')) return;
      $$('.drawer.is-open, .modal.is-open').forEach((o) => o !== el && overlay.close(o, true));
      lastFocus = document.activeElement;
      el.hidden = false;
      el.setAttribute('aria-hidden', 'false');
      void el.offsetWidth;
      el.classList.add('is-open');
      html.style.overflow = 'hidden';
      const first = $('button[data-close]', el);
      if (first) first.focus({ preventScroll: true });
    },
    close(el, keepLock) {
      if (!el || !el.classList.contains('is-open')) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (!keepLock) html.style.overflow = '';
      setTimeout(() => {
        if (!el.classList.contains('is-open')) el.hidden = true;
      }, 360);
      if (!keepLock && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  });

  /* ---------------------------------------------------------------- Carrito */
  const cartDrawer = () => document.getElementById('CartDrawer');
  const cart = (JG.cart = {
    sectionIds() {
      const ids = ['cart-drawer'];
      const page = $('[data-cart-page]');
      const sec = page && page.closest('.shopify-section');
      if (sec) ids.push(sec.id.replace('shopify-section-', ''));
      return ids;
    },
    async request(url, payload) {
      const body = Object.assign({ sections: this.sectionIds().join(','), sections_url: location.pathname }, payload);
      const res = await fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'No pudimos actualizar tu carrito. Inténtalo de nuevo.');
      this.render(data.sections);
      return data;
    },
    add(id, quantity = 1) {
      return this.request(JG.routes.cartAdd, { items: [{ id: Number(id), quantity }] });
    },
    change(key, quantity) {
      return this.request(JG.routes.cartChange, { id: key, quantity });
    },
    async refresh() {
      try {
        const res = await fetch(`${JG.routes.root}?sections=${this.sectionIds().join(',')}`);
        if (res.ok) this.render(await res.json());
      } catch (e) {}
    },
    render(sections) {
      if (!sections) return;
      Object.keys(sections).forEach((id) => {
        if (!sections[id]) return;
        const doc = parseHTML(sections[id]);
        if (id === 'cart-drawer') {
          const next = $('[data-cart-panel]', doc);
          const cur = $('[data-cart-panel]', cartDrawer() || document);
          if (!next || !cur) return;
          cur.innerHTML = next.innerHTML;
          cur.dataset.count = next.dataset.count;
          this.count(parseInt(next.dataset.count, 10) || 0);
        } else {
          const cur = document.getElementById('shopify-section-' + id);
          const next = doc.getElementById('shopify-section-' + id);
          if (cur && next) cur.innerHTML = next.innerHTML;
        }
      });
    },
    count(n) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = n;
        el.hidden = n === 0;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      });
    },
    open() {
      overlay.open(cartDrawer());
    }
  });

  const lineUpdate = async (item, qty) => {
    if (!item) return;
    item.classList.add('is-busy');
    try {
      await cart.change(item.dataset.key, qty);
    } catch (err) {
      JG.toast(err.message, 'err');
      item.classList.remove('is-busy');
    }
  };

  /* ------------------------------------------------------------ Vista rápida */
  const quickView = async (url) => {
    const modal = document.getElementById('QuickView');
    if (!modal) return (location.href = url);
    const body = $('[data-quick-body]', modal);
    body.innerHTML = '<div class="modal__loading"><span class="spinner"></span></div>';
    overlay.open(modal);
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('view', 'quick');
      const res = await fetch(u);
      if (!res.ok) throw new Error('quick');
      body.innerHTML = await res.text();
    } catch (e) {
      location.href = url;
    }
  };

  const closeSheets = (except) => {
    $$('.pcard__sheet:not([hidden])').forEach((s) => {
      if (s === except) return;
      s.hidden = true;
      const btn = $('[data-sheet-open]', s.closest('.pcard'));
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };

  /* ------------------------------------------------------- Clics delegados */
  document.addEventListener('click', async (e) => {
    const t = e.target;

    const opener = t.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      overlay.open(document.getElementById(opener.dataset.open));
      return;
    }
    const closer = t.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      overlay.close(closer.closest('.drawer, .modal'));
      return;
    }

    const openCart = t.closest('[data-open-cart]');
    if (openCart && JG.template !== 'cart') {
      e.preventDefault();
      cart.open();
      return;
    }

    const addBtn = t.closest('[data-add-variant]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.classList.contains('is-loading')) return;
      addBtn.classList.add('is-loading');
      try {
        await cart.add(addBtn.dataset.addVariant);
        closeSheets();
        cart.open();
      } catch (err) {
        JG.toast(err.message, 'err');
      } finally {
        addBtn.classList.remove('is-loading');
      }
      return;
    }

    const sheetBtn = t.closest('[data-sheet-open]');
    if (sheetBtn) {
      e.preventDefault();
      const sheet = $('.pcard__sheet', sheetBtn.closest('.pcard'));
      if (!sheet) return;
      const willOpen = sheet.hidden;
      closeSheets();
      sheet.hidden = !willOpen;
      sheetBtn.setAttribute('aria-expanded', String(willOpen));
      return;
    }
    if (t.closest('[data-sheet-close]')) {
      e.preventDefault();
      closeSheets();
      return;
    }
    if (!t.closest('.pcard__sheet')) closeSheets();

    const qv = t.closest('[data-quick-view]');
    if (qv) {
      e.preventDefault();
      quickView(qv.dataset.quickView);
      return;
    }

    const qtyBtn = t.closest('[data-qty-change]');
    if (qtyBtn) {
      const item = qtyBtn.closest('.citem');
      const input = $('[data-qty-input]', item);
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.dataset.qtyChange, 10));
      lineUpdate(item, next);
      return;
    }
    const rm = t.closest('[data-remove]');
    if (rm) {
      lineUpdate(rm.closest('.citem'), 0);
      return;
    }

    if (t.closest('[data-focus-search]')) {
      const input = $('[data-search-input]');
      if (input) {
        input.focus();
        input.select();
      }
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-qty-input]')) {
      lineUpdate(e.target.closest('.citem'), Math.max(0, parseInt(e.target.value, 10) || 0));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = $('.drawer.is-open, .modal.is-open');
    if (open) overlay.close(open);
    closeSheets();
  });

  /* ------------------------------------------------ Formulario de producto */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter || $('[data-add-btn]', form);
    const errBox = $('[data-form-error]', form);
    const fd = new FormData(form);
    if (errBox) errBox.hidden = true;
    if (btn) btn.classList.add('is-loading');
    const buyNow = !!(e.submitter && e.submitter.hasAttribute('data-buy-now'));
    try {
      await cart.add(fd.get('id'), parseInt(fd.get('quantity'), 10) || 1);
      if (buyNow) {
        location.href = JG.routes.checkout;
        return;
      }
      cart.open();
    } catch (err) {
      if (errBox) {
        errBox.textContent = err.message;
        errBox.hidden = false;
      } else {
        JG.toast(err.message, 'err');
      }
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  /* ------------------------------------------------- Vistos recientemente */
  const recent = {
    key: 'jg-recent',
    get() {
      try {
        return JSON.parse(localStorage.getItem(this.key)) || [];
      } catch (e) {
        return [];
      }
    },
    push(handle) {
      if (!handle) return;
      try {
        const list = this.get().filter((h) => h !== handle);
        list.unshift(handle);
        localStorage.setItem(this.key, JSON.stringify(list.slice(0, 16)));
      } catch (e) {}
    }
  };

  /* ------------------------------------------------------ Animación de entrada */
  const reveal = {
    io:
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) =>
              entries.forEach((en) => {
                if (!en.isIntersecting) return;
                en.target.classList.add('is-in');
                reveal.io.unobserve(en.target);
              }),
            { rootMargin: '0px 0px -6% 0px', threshold: 0.04 }
          )
        : null,
    scan(root = document) {
      const design = window.Shopify && window.Shopify.designMode;
      $$('.reveal:not(.is-in)', root).forEach((el) => {
        if (this.io && !design) this.io.observe(el);
        else el.classList.add('is-in');
      });
    }
  };


  /* ------------------------------------------- Índice local del catálogo */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) =>
    String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  const editDistance = (a, b, max) => {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
    for (let i = 1; i <= a.length; i++) {
      const cur = [i];
      let rowMin = i;
      for (let j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  };
  const PF_LABEL = { switch2: 'Nintendo Switch 2', switch: 'Nintendo Switch', ps5: 'Solo PS5', ps4: 'PS4 · PS5', xbox: 'Xbox' };

  const catalog = (JG.catalog = {
    key: 'jg-index-v2',
    ttl: 15 * 60 * 1000,
    load() {
      if (this.data) return Promise.resolve(this.data);
      if (this.pending) return this.pending;
      this.pending = (async () => {
        const fresh = (data) => {
          const d = hoy();
          data.products.forEach((p) => p.of && d > p.of && Object.assign(p, { p: p.r, c: null, of: null }));
          return data;
        };
        try {
          const cached = JSON.parse(sessionStorage.getItem(this.key) || 'null');
          if (cached && Date.now() - cached.ts < this.ttl) return (this.data = fresh(cached));
        } catch (e) {}
        const base = `${JG.routes.root}collections/all?view=jg-index&page=`;
        const get = async (page) => {
          const res = await fetch(base + page);
          if (!res.ok) throw new Error('index');
          return JSON.parse(await res.text());
        };
        const first = await get(1);
        let products = first.products || [];
        for (let page = 2; page <= (first.pages || 1); page++) products = products.concat((await get(page)).products || []);
        const data = {
          ts: Date.now(),
          products: products.map((p) => Object.assign(p, { n: norm(p.k ? p.t + ' ' + p.k : p.t) })),
          collections: (first.collections || []).map((c) => Object.assign(c, { n: norm(c.t) }))
        };
        try {
          sessionStorage.setItem(this.key, JSON.stringify(data));
        } catch (e) {}
        return (this.data = fresh(data));
      })().catch((err) => {
        this.pending = null;
        throw err;
      });
      return this.pending;
    },
    search(query, data) {
      const tokens = norm(query).split(' ').filter(Boolean);
      if (!tokens.length) return { products: [], collections: [] };
      const phrase = tokens.join(' ');
      const exact = (n) => {
        let score = 0;
        for (const t of tokens) {
          const i = n.indexOf(t);
          if (i < 0) return -1;
          score += i === 0 ? 4 : n[i - 1] === ' ' ? 3 : 1;
        }
        if (n.includes(phrase)) score += 3;
        if (n.startsWith(phrase)) score += 3;
        return score;
      };
      const fuzzy = (n) => {
        const words = n.split(' ');
        let score = 0;
        for (const t of tokens) {
          if (n.includes(t)) {
            score += 2;
            continue;
          }
          const max = t.length >= 7 ? 2 : t.length >= 4 ? 1 : 0;
          if (!max || !words.some((w) => editDistance(t, w.slice(0, t.length + 1), max) <= max)) return -1;
          score += 1;
        }
        return score;
      };
      const rank = (list, fn) =>
        list
          .map((item) => ({ item, score: fn(item.n) }))
          .filter((r) => r.score >= 0)
          .sort((a, b) => b.score - a.score || Number(b.item.a !== false) - Number(a.item.a !== false) || a.item.t.length - b.item.t.length)
          .map((r) => r.item);
      let products = rank(data.products, exact);
      if (!products.length) products = rank(data.products, fuzzy);
      return { products, collections: rank(data.collections, exact) };
    },
    url(p) {
      return `${JG.routes.root}products/${encodeURIComponent(p.h)}`;
    }
  });

  /* --------------------------------------------------------- Componentes */
  class JGRotator extends HTMLElement {
    connectedCallback() {
      const items = Array.from(this.children);
      if (items.length < 2 || reduce) return;
      let i = 0;
      this.timer = setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (parseInt(this.dataset.interval, 10) || 4) * 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  class JGSlider extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      this.slides = $$('[data-slide]', this);
      this.dots = $$('[data-dot]', this);
      this.i = 0;
      if (!this.track || this.slides.length < 2) return;

      const prev = $('[data-prev]', this);
      const next = $('[data-next]', this);
      if (prev) prev.addEventListener('click', () => this.go(this.i - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.i + 1, true));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(Number(d.dataset.dot), true)));

      let raf;
      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.i) {
              this.i = i;
              this.paint();
            }
          });
        },
        { passive: true }
      );

      this.auto = this.dataset.autoplay === 'true' && !reduce && !(window.Shopify && window.Shopify.designMode);
      this.ms = (parseInt(this.dataset.interval, 10) || 6) * 1000;
      ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
      ['pointerleave', 'focusout', 'touchend'].forEach((ev) => this.addEventListener(ev, () => this.start(), { passive: true }));
      this.onVis = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVis);
      this.addEventListener('shopify:block:select', (e) => {
        const idx = this.slides.indexOf(e.target);
        if (idx > -1) this.go(idx);
      });
      this.start();
    }
    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVis);
    }
    go(i, user) {
      const n = this.slides.length;
      this.i = (i + n) % n;
      this.track.scrollTo({ left: this.i * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      this.paint();
      if (user) {
        this.stop();
        this.start();
      }
    }
    paint() {
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.i));
    }
    start() {
      if (!this.auto || this.timer) return;
      this.timer = setInterval(() => this.go(this.i + 1), this.ms);
    }
    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  class JGRail extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      if (!this.track) return;
      const prev = $('[data-prev]', this);
      const next = $('[data-next]', this);
      const step = () => Math.max(this.track.clientWidth * 0.85, 200);
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 4;
        if (prev) prev.disabled = this.track.scrollLeft <= 4;
        if (next) next.disabled = this.track.scrollLeft >= max;
      };
      this.track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(this.track);
      if ('MutationObserver' in window) new MutationObserver(update).observe(this.track, { childList: true });
      update();
    }
  }

  class JGTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = $$('[role="tab"]', this);
      this.panels = $$('[role="tabpanel"]', this);
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.show(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.show(n);
          this.tabs[n].focus();
        });
      });
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.tabs.indexOf(e.target);
        if (i > -1) this.show(i);
      });
    }
    show(i) {
      this.tabs.forEach((tab, k) => {
        tab.classList.toggle('is-active', k === i);
        tab.setAttribute('aria-selected', String(k === i));
        tab.tabIndex = k === i ? 0 : -1;
      });
      this.panels.forEach((p, k) => (p.hidden = k !== i));
      const list = this.tabs[i].parentElement;
      if (list) list.scrollTo({ left: this.tabs[i].offsetLeft - list.clientWidth / 2 + this.tabs[i].clientWidth / 2, behavior: 'smooth' });
    }
  }

  class JGCounter extends HTMLElement {
    connectedCallback() {
      const to = parseFloat(this.dataset.to) || 0;
      const fmt = new Intl.NumberFormat('es-MX');
      this.textContent = fmt.format(to);
      if (reduce || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(
        ([en]) => {
          if (!en.isIntersecting) return;
          io.disconnect();
          const t0 = performance.now();
          const tick = (t) => {
            const p = Math.min(1, (t - t0) / 1400);
            this.textContent = fmt.format(Math.round(to * (1 - Math.pow(1 - p, 3))));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        },
        { threshold: 0.4 }
      );
      io.observe(this);
    }
  }

  class JGSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('[data-search-input]', this);
      this.panel = $('[data-search-panel]', this);
      this.results = $('[data-search-results]', this);
      this.clearBtn = $('[data-search-clear]', this);
      if (!this.input || !this.panel) return;
      this.terms = (this.dataset.terms || '')
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean);

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => {
        this.open();
        catalog.load().catch(() => {});
      });
      if (this.clearBtn) {
        this.clearBtn.hidden = !this.input.value;
        this.clearBtn.addEventListener('click', () => {
          this.input.value = '';
          this.onInput();
          this.input.focus();
        });
      }
      this.onDoc = (e) => {
        if (!this.contains(e.target) && !e.target.closest('[data-focus-search]')) this.close();
      };
      document.addEventListener('click', this.onDoc);
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.close();
          this.input.blur();
        }
      });
      this.rotate();
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onDoc);
      clearInterval(this.rot);
    }
    open() {
      if (this.terms.length || this.results.innerHTML.trim()) this.panel.hidden = false;
    }
    close() {
      this.panel.hidden = true;
    }
    onInput() {
      const q = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.hidden = !q;
      clearTimeout(this.timer);
      if (q.length < 2) {
        this.results.innerHTML = '';
        this.panel.classList.remove('has-results');
        if (this.terms.length) this.panel.hidden = false;
        else this.close();
        return;
      }
      this.panel.hidden = false;
      this.panel.classList.add('has-results');
      if (!catalog.data && !$('.ps', this.results)) this.results.innerHTML = '<div class="ps__loading"><i></i><i></i><i></i></div>';
      catalog
        .load()
        .then((data) => {
          if (this.input.value.trim() === q) this.results.innerHTML = this.render(q, catalog.search(q, data));
        })
        .catch(() => {
          this.results.innerHTML = '';
          this.panel.classList.remove('has-results');
        });
    }
    render(q, found) {
      const cols = found.collections.slice(0, 4);
      const prods = found.products.slice(0, 6);
      let out = '<div class="ps">';
      if (cols.length) {
        out += `<div class="chips ps__chips">${cols.map((c) => `<a class="chip chip--accent" href="${esc(c.u)}">${esc(c.t)}</a>`).join('')}</div>`;
      }
      if (prods.length) {
        out += '<ul class="ps__list">';
        out += prods
          .map(
            (p) => `<li><a class="ps__item pf-${esc(p.pf)}" href="${catalog.url(p)}">
              <span class="ps__img">${p.i ? `<img src="${esc(p.i)}" alt="" width="44" height="70">` : ''}</span>
              <span class="ps__info">${PF_LABEL[p.pf] ? `<small class="pcard__pf">${PF_LABEL[p.pf]}</small>` : ''}<b>${esc(p.t)}</b></span>
              <span class="ps__price"><span class="price${p.c ? ' price--sale' : ''}">${p.v ? '<span class="price__from">Desde</span>' : ''}<span class="price__now">${esc(p.p)}</span>${p.c ? `<s class="price__was">${esc(p.c)}</s>` : ''}</span></span>
            </a></li>`
          )
          .join('');
        out += '</ul>';
        const n = found.products.length;
        out += `<a class="ps__all" href="${JG.routes.search}?type=product&q=${encodeURIComponent(q)}">Ver ${n === 1 ? 'el resultado' : `los ${n} resultados`} de “${esc(q)}”</a>`;
      } else {
        out += `<p class="ps__none">No encontramos “${esc(q)}”. Prueba con otro nombre.</p>`;
      }
      return out + '</div>';
    }
    rotate() {
      if (!this.terms.length || reduce) return;
      const base = this.input.placeholder;
      let i = 0;
      this.rot = setInterval(() => {
        if (document.activeElement === this.input || this.input.value) return;
        i = (i + 1) % (this.terms.length + 1);
        this.input.placeholder = i === 0 ? base : `Busca “${this.terms[i - 1]}”`;
      }, 2600);
    }
  }

  class JGProduct extends HTMLElement {
    connectedCallback() {
      const data = $('[data-variants]', this);
      try {
        this.variants = JSON.parse(data ? data.textContent : '[]');
      } catch (e) {
        this.variants = [];
      }
      this.isMain = this.hasAttribute('data-main');
      if (data && data.dataset.ofertaFin && hoy() > data.dataset.ofertaFin) {
        this.variants.forEach((v) => v.regular && Object.assign(v, { price: v.regular, compare: null, save: null }));
        const input = $('input[data-variant-input]:checked', this) || $('select[data-variant-input]', this) || $('[name="id"]', this);
        if (input) this.paint(this.variants.find((x) => String(x.id) === String(input.value)));
      }
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-variant-input]')) this.update(e.target.value);
      });
      this.addEventListener('click', (e) => {
        const th = e.target.closest('.pdp__thumb');
        if (th) this.setMedia(th);
      });
      if (this.isMain) {
        this.sticky();
        recent.push(this.dataset.handle);
      }
    }
    update(id) {
      const v = this.variants.find((x) => String(x.id) === String(id));
      if (!v) return;
      const each = (sel, fn, root = this) => $$(sel, root).forEach(fn);
      each('[data-variant-id]', (el) => (el.value = v.id));
      this.paint(v);
      each('[data-add-btn], [data-buy-now]', (el) => (el.disabled = !v.available));
      each('[data-add-label]', (el) => (el.textContent = v.available ? 'Agregar al carrito' : 'Agotado'));
      const sec = this.closest('.pdp');
      if (sec) each('[data-sticky-btn]', (el) => (el.disabled = !v.available), sec);
      if (v.media) {
        const th = $(`.pdp__thumb[data-media-id="${v.media}"]`, this);
        if (th) this.setMedia(th);
      }
      if (this.isMain) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url);
      }
    }
    paint(v) {
      if (!v) return;
      const each = (sel, fn, root = this) => $$(sel, root).forEach(fn);
      each('[data-price-now]', (el) => (el.textContent = v.price));
      each('[data-price-was]', (el) => {
        el.hidden = !v.compare;
        el.textContent = v.compare || '';
      });
      each('[data-price-save]', (el) => {
        el.hidden = !v.save;
        const b = $('b', el);
        if (b) b.textContent = v.save || '';
      });
      const sec = this.closest('.pdp');
      if (sec) each('[data-sticky-price]', (el) => (el.textContent = this.variants.length > 1 ? `${v.price} · ${v.title}` : v.price), sec);
    }
    setMedia(th) {
      const img = $('[data-main-media] img', this);
      if (!img || !th.dataset.src) return;
      img.removeAttribute('srcset');
      img.src = th.dataset.src;
      $$('.pdp__thumb', this).forEach((t) => t.classList.toggle('is-active', t === th));
    }
    sticky() {
      const sec = this.closest('.pdp');
      const bar = sec && $('[data-sticky-atc]', sec);
      const btn = $('[data-add-btn]', this);
      if (!bar || !btn || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([en]) => {
        bar.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
      }).observe(btn);
    }
  }

  class JGCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.addEventListener('click', (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        const more = e.target.closest('[data-load-more]');
        if (more) {
          e.preventDefault();
          this.more(more);
          return;
        }
        const a = e.target.closest('a[data-ajax-nav]');
        if (a) {
          e.preventDefault();
          this.load(a.href, true);
        }
      });
      this.addEventListener('change', (e) => {
        if (!e.target.matches('[data-sort]')) return;
        const url = new URL(location.href);
        url.searchParams.set('sort_by', e.target.value);
        url.searchParams.delete('page');
        this.load(url.toString(), true);
      });
      this.onPop = () => this.load(location.href, false);
      window.addEventListener('popstate', this.onPop);
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPop);
    }
    async get(href) {
      const url = new URL(href, location.origin);
      url.searchParams.set('section_id', this.sectionId);
      const res = await fetch(url);
      if (!res.ok) throw new Error('collection');
      return parseHTML(await res.text());
    }
    async load(href, push) {
      this.classList.add('is-loading');
      try {
        const next = $('jg-collection', await this.get(href));
        if (!next) throw new Error('empty');
        this.innerHTML = next.innerHTML;
        this.className = next.className;
        if (push) history.pushState({}, '', href);
        const top = this.getBoundingClientRect().top + scrollY - 120;
        if (scrollY > top) scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
        reveal.scan(this);
      } catch (e) {
        location.href = href;
      } finally {
        this.classList.remove('is-loading');
      }
    }
    async more(btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      try {
        const doc = await this.get(btn.href);
        const grid = $('[data-grid]', this);
        $$('[data-grid] > *', doc).forEach((card) => grid.appendChild(document.importNode(card, true)));
        const nextMore = $('.coll__more', doc);
        const curMore = $('.coll__more', this);
        if (nextMore && curMore) curMore.innerHTML = nextMore.innerHTML;
        else if (curMore) curMore.remove();
      } catch (e) {
        location.href = btn.href;
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }

  class JGRecs extends HTMLElement {
    connectedCallback() {
      if (this.children.length || !this.dataset.url || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(
        ([en]) => {
          if (!en.isIntersecting) return;
          io.disconnect();
          fetch(this.dataset.url)
            .then((r) => r.text())
            .then((txt) => {
              const el = $('jg-recs', parseHTML(txt));
              if (el && el.innerHTML.trim()) {
                this.innerHTML = el.innerHTML;
                reveal.scan(this);
              }
            })
            .catch(() => {});
        },
        { rootMargin: '0px 0px 700px 0px' }
      );
      io.observe(this);
    }
  }

  class JGRecent extends HTMLElement {
    async connectedCallback() {
      const limit = parseInt(this.dataset.limit, 10) || 8;
      const current = this.dataset.current;
      const handles = recent
        .get()
        .filter((h) => h !== current)
        .slice(0, limit);
      const track = $('[data-recent-track]', this);
      if (handles.length < 2 || !track) return;
      const cards = await Promise.all(
        handles.map((h) =>
          fetch(`${JG.routes.root}products/${encodeURIComponent(h)}?view=card`)
            .then((r) => (r.ok ? r.text() : ''))
            .catch(() => '')
        )
      );
      cards
        .filter((c) => c.includes('pcard'))
        .forEach((c) => {
          const item = document.createElement('div');
          item.className = 'rail__item';
          item.innerHTML = c;
          track.appendChild(item);
        });
      if (track.children.length > 1) {
        this.hidden = false;
        reveal.scan(this);
      }
    }
  }


  class JGResults extends HTMLElement {
    async connectedCallback() {
      const q = this.dataset.q;
      const grid = $('[data-results-grid]', this);
      if (!q || !grid) return;
      let found;
      try {
        found = catalog.search(q, await catalog.load()).products;
      } catch (e) {
        return;
      }
      const have = new Set(
        $$('.pcard__title a', grid).map((a) => {
          const m = a.getAttribute('href').match(/\/products\/([^?#]+)/);
          return m ? decodeURIComponent(m[1]) : '';
        })
      );
      const missing = found.filter((p) => !have.has(p.h)).slice(0, 48);
      if (!missing.length) return;
      const cards = await Promise.all(
        missing.map((p) =>
          fetch(`${catalog.url(p)}?view=card`)
            .then((r) => (r.ok ? r.text() : ''))
            .catch(() => '')
        )
      );
      const frag = document.createDocumentFragment();
      cards
        .filter((c) => c.includes('pcard'))
        .forEach((c) => {
          const tpl = document.createElement('template');
          tpl.innerHTML = c.trim();
          frag.appendChild(tpl.content);
        });
      grid.appendChild(frag);
      const total = $$('.pcard, .result-card', grid).length;
      const count = $('[data-results-count]', this);
      const empty = $('[data-results-empty]', this);
      if (count && total) {
        count.hidden = false;
        count.innerHTML = `<b>${total}</b> resultado${total === 1 ? '' : 's'}`;
      }
      if (empty && total) empty.hidden = true;
    }
  }

  let reviewsData;
  const loadReviews = (src) => reviewsData || (reviewsData = fetch(src).then((r) => r.json()));

  class JGReviews extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.list = $('[data-list]', this);
      this.tpl = $('template[data-card]', this);
      if (!this.list || !this.tpl) return;
      const start = () =>
        loadReviews(this.dataset.src)
          .then((d) => this.render(d.items || []))
          .catch(() => this.parentElement.classList.add('is-empty'));
      if (this.dataset.mode === 'wall' || !('IntersectionObserver' in window)) {
        start();
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          io.disconnect();
          start();
        },
        { rootMargin: '500px' }
      );
      io.observe(this);
    }
    card([name, date, text]) {
      const el = this.tpl.content.firstElementChild.cloneNode(true);
      const [y, m] = date.split('-');
      $('[data-av]', el).textContent = name.charAt(0);
      $('[data-name]', el).textContent = name;
      $('[data-when]', el).textContent = new Date(+y, +m - 1, 1).toLocaleDateString('es-MX', { month: 'short', year: 'numeric' });
      $('[data-text]', el).textContent = text;
      if (text.length > 260) {
        const more = $('[data-more]', el);
        el.classList.add('is-long');
        more.hidden = false;
        more.addEventListener('click', () => {
          more.textContent = el.classList.toggle('is-open') ? 'Ver menos' : 'Ver más';
        });
      }
      return el;
    }
    render(items) {
      if (this.dataset.mode === 'wall') {
        this.wall(items);
        return;
      }
      const limit = parseInt(this.dataset.limit, 10) || 12;
      const pool = items.filter((it) => it[2].length >= 40 && it[2].length <= 240).slice(0, 300);
      for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      this.list.textContent = '';
      pool.slice(0, limit).forEach((it) => {
        const el = this.card(it);
        el.classList.add('rail__item');
        this.list.appendChild(el);
      });
    }
    wall(items) {
      const input = $('[data-q]', this);
      const btn = $('[data-load]', this);
      const count = $('[data-count]', this);
      const none = $('[data-none]', this);
      const index = items.map((it) => norm(`${it[0]} ${it[2]}`));
      const num = (n) => n.toLocaleString('es-MX');
      let found = items;
      let shown = 0;
      const more = () => {
        const page = document.createElement('div');
        page.className = 'revs__page';
        found.slice(shown, shown + 24).forEach((it) => page.appendChild(this.card(it)));
        shown = Math.min(shown + 24, found.length);
        this.list.appendChild(page);
        btn.hidden = shown >= found.length;
        count.innerHTML = `Mostrando <b>${num(shown)}</b> de <b>${num(found.length)}</b>`;
      };
      const search = () => {
        const words = norm(input.value).split(' ').filter(Boolean);
        found = words.length ? items.filter((_, i) => words.every((w) => index[i].includes(w))) : items;
        shown = 0;
        this.list.textContent = '';
        none.hidden = found.length > 0;
        count.hidden = !found.length;
        more();
      };
      let timer;
      btn.addEventListener('click', more);
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(search, 160);
      });
      search();
    }
  }

  define('jg-rotator', JGRotator);
  define('jg-slider', JGSlider);
  define('jg-rail', JGRail);
  define('jg-tabs', JGTabs);
  define('jg-counter', JGCounter);
  define('jg-search', JGSearch);
  define('jg-product', JGProduct);
  define('jg-collection', JGCollection);
  define('jg-recs', JGRecs);
  define('jg-recent', JGRecent);
  define('jg-results', JGResults);
  define('jg-reviews', JGReviews);

  /* ------------------------------------------------------------ Encabezado */
  const initHeader = () => {
    const header = $('[data-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = '1';

    const items = $$('[data-dropdown]', header);
    const setOpen = (it, open) => {
      it.classList.toggle('is-open', open);
      const btn = $('button', it);
      if (btn) btn.setAttribute('aria-expanded', String(open));
    };
    const closeAll = (except) => items.forEach((it) => it !== except && setOpen(it, false));
    items.forEach((it) => {
      let timer;
      const open = () => {
        clearTimeout(timer);
        closeAll(it);
        setOpen(it, true);
      };
      const close = () => {
        timer = setTimeout(() => setOpen(it, false), 160);
      };
      if (canHover) {
        it.addEventListener('pointerenter', open);
        it.addEventListener('pointerleave', close);
      }
      const btn = $('button', it);
      if (btn) btn.addEventListener('click', () => (it.classList.contains('is-open') && !canHover ? setOpen(it, false) : open()));
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-dropdown]')) closeAll();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    /* El contenedor guarda el alto del encabezado abierto: si cambiara al plegarse, el navegador
       recolocaría el scroll y eso se leería como un cambio de dirección (abre y cierra sin parar). */
    const wrap = header.closest('.sec-header');
    let fitWidth = 0;
    const fit = () => {
      if (!wrap) return;
      const collapsed = header.classList.contains('is-collapsed');
      header.classList.add('is-fitting');
      header.classList.remove('is-collapsed');
      wrap.style.height = header.getBoundingClientRect().height + 'px';
      header.classList.toggle('is-collapsed', collapsed);
      void header.offsetHeight;
      header.classList.remove('is-fitting');
      fitWidth = innerWidth;
    };
    fit();
    addEventListener('resize', () => innerWidth !== fitWidth && fit());
    addEventListener('load', fit);

    let last = scrollY;
    let ticking = false;
    const onScroll = () => {
      const y = scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      if (Math.abs(y - last) > 8) {
        const down = y > last && y > 260;
        if (!$('.nav__item.is-open', header)) header.classList.toggle('is-collapsed', down);
        last = y;
      }
      ticking = false;
    };
    addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(onScroll);
      },
      { passive: true }
    );
    onScroll();
  };

  /* ------------------------------------------- Inclinación 3D del pedestal */
  if (canHover && !reduce) {
    document.addEventListener(
      'pointermove',
      (e) => {
        const st = e.target.closest && e.target.closest('[data-tilt]');
        if (!st) return;
        const r = st.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        st.style.setProperty('--ry', (x * 28).toFixed(1) + 'deg');
        st.style.setProperty('--rx', (-y * 14).toFixed(1) + 'deg');
      },
      { passive: true }
    );
    document.addEventListener('pointerout', (e) => {
      const st = e.target.closest && e.target.closest('[data-tilt]');
      if (st && !st.contains(e.relatedTarget)) {
        st.style.removeProperty('--ry');
        st.style.removeProperty('--rx');
      }
    });
  }

  /* -------------------------------------------------------- Promoción 3x2 */
  /* Los avisos los pinta Liquid (snippets/promo3x2.liquid) y los enciende la clase "promo3x2" de <html>. Aquí solo
     van la cuenta regresiva (el reloj del cintillo de la portada y, el último día, la de los demás avisos) y apagar la caja de la ficha cuando la modalidad elegida no entra. */
  const promo3x2 = () => {
    const p = window.JG_PROMO3X2;
    if (!p) return;
    const dos = (n) => String(n).padStart(2, '0');
    const pon = (el, txt) => {
      const t = el.firstChild;
      if (t && t.nodeType === 3 && !t.nextSibling) {
        if (t.nodeValue !== txt) t.nodeValue = txt;
      } else {
        el.textContent = txt;
      }
    };
    const tic = () => {
      const falta = p.fin - Date.now();
      if (falta <= 0) {
        html.classList.remove('promo3x2');
        return;
      }
      if (!html.classList.contains('promo3x2')) return;
      const h = Math.floor(falta / 3600000);
      const m = dos(Math.floor((falta % 3600000) / 60000));
      const s = dos(Math.floor((falta % 60000) / 1000));
      const reloj = { d: String(Math.floor(h / 24)), h: dos(h % 24), m, s };
      $$('[data-p3-reloj]').forEach((el) => {
        Object.keys(reloj).forEach((k) => {
          const n = $(`[data-${k}]`, el);
          if (n) pon(n, reloj[k]);
        });
      });
      if (falta >= 86400000) return;
      const txt = `Termina en ${dos(h)}:${m}:${s}`;
      $$('[data-p3-cuenta]').forEach((el) => pon(el, txt));
    };
    tic();
    setInterval(tic, 1000);
    document.addEventListener('change', (e) => {
      const el = e.target;
      if (!el.matches || !el.matches('[data-variant-input]') || !el.form) return;
      const box = $('[data-p3-box]', el.form);
      if (box) box.classList.toggle('is-off', !`,${box.dataset.ids}`.includes(`,${el.value},`));
    });
  };

  /* ------------------------------------------------------------- Arranque */
  const boot = () => {
    initHeader();
    reveal.scan();
    vigencia();
    promo3x2();
    if ('MutationObserver' in window) {
      let queued = 0;
      new MutationObserver(() => {
        cancelAnimationFrame(queued);
        queued = requestAnimationFrame(() => vigencia());
      }).observe(document.body, { childList: true, subtree: true });
    }
    html.classList.add('jg-ready');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  addEventListener('pageshow', (e) => {
    if (e.persisted) cart.refresh();
  });

  document.addEventListener('shopify:section:load', (e) => {
    const header = $('[data-header]', e.target);
    if (header) {
      delete header.dataset.ready;
      initHeader();
    }
    reveal.scan(e.target);
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.id === 'shopify-section-cart-drawer') cart.open();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.id === 'shopify-section-cart-drawer') overlay.close(cartDrawer());
  });
})();
